import HeaderWaiterLayout from "./HeaderWaiterLayout/HeaderWaiterLayout";

const WaiterLayout = ({ children }) => {
  return (
    <div className="bg">
      <HeaderWaiterLayout />
      <div className="wrapper">{children}</div>
    </div>
  );
};

export default WaiterLayout;
